// state
const state = {
  HEADER: {
    _hidden: false,
    _filters_loaded: false
  },
  FOOTER: {
    _hidden: false
  },
  SAFEZONE: {
    _hidden: false
  },
  PHOTO_PREVIEW: {
    _hidden: true,
    _params: {}
  },
  DYNAMIC_ISLAND: {
    _hidden: true,
    _params: {}
  },
  RELOAD_CONTENT: false,
  layoutChanged: false
}

// getters
const getters = {
  Header: state => state.HEADER,
  headerLoaded: state => {
    return new Promise(resolve => {
      const interval = setInterval(() => {
        if (state.HEADER._filters_loaded) {
          clearInterval(interval)
          resolve()
        }
      }, 333)
    })
  },
  Footer: state => state.FOOTER,
  SafeZone: state => state.SAFEZONE,
  Island: state => state.DYNAMIC_ISLAND,
  PhotoPreview: state => state.PHOTO_PREVIEW,
  layoutChanged: state => state.layoutChanged,
  ReloadContent: state => state.RELOAD_CONTENT
}

// actions
const actions = {}

// mutations
const mutations = {
  toggleHeader(state) {
    state.HEADER._hidden = !state.HEADER._hidden
  },
  setHeaderLoadedState(state, data) {
    state.HEADER._filters_loaded = data
  },
  toggleFooter(state) {
    state.FOOTER._hidden = !state.FOOTER._hidden
  },
  toggleSafeZone(state) {
    state.SAFEZONE._hidden = !state.SAFEZONE._hidden
  },
  setDynamicIsland(state, {data, hidden}) {
    state.DYNAMIC_ISLAND._hidden = hidden
    state.DYNAMIC_ISLAND._params = data
  },
  togglePhotoPreview(state) {
    state.PHOTO_PREVIEW._hidden = !state.PHOTO_PREVIEW._hidden
  },
  setPhotoPreview(state, data) {
    state.PHOTO_PREVIEW._params = data
  },
  emitContentReload(state) {
    state.RELOAD_CONTENT = !state.RELOAD_CONTENT
  },
  initLayout(state) {
    state.layoutChanged = !state.layoutChanged
  }
}

export default {
  namespaced: true,
  namespace: 'layout',
  state,
  getters,
  actions,
  mutations
}
